import { FONTS, COLORS } from 'constants/index';
import styled from 'styled-components';

export const LogoWrapper = styled.div`
    padding: 16px 16px 0px 16px;
    font-family: ${FONTS};
    color: ${COLORS.SECONDARY};
    cursor: pointer;
`;

export const KurrentLogoWrapper = styled.div`
    //padding: 16px 16px 0px 16px;
    font-family: ${FONTS};
    color: ${COLORS.SECONDARY};
    cursor: pointer;
    width: 150px;
`;

export const MenuWrapper = styled.div`
    display: flex;
    justify-content: flex-end;
`;
